import axios from 'axios';

export default class PARequest {
  constructor(parameters){
    this.baseURL      = parameters.baseURL;

    this.tokenType    = parameters.tokenType;

    if(typeof parameters.accessToken !== 'undefined'){
      this.accessToken = parameters.accessToken;
    }else{
      this.accessToken = null;
    }

    if(typeof parameters.refreshToken !== 'undefined'){
      this.refreshToken = parameters.refreshToken;
    }else{
      this.refreshToken = null;
    }

    if(typeof parameters.csrfToken !== 'undefined'){
      this.csrfToken = parameters.csrfToken;
    }else{
      this.csrfToken = null;
    }

    this.axiosObject  = null;
  }

  async apiRequest(payload){
    if(this.isRequireReAuthencation()){
      return {
        status    : 401,
        data      : null,
      };
    }

    if(this.axiosObject === null){
      this.axiosObject = this.initializeAxiosObject();
    }

    let results = null;

    switch(payload.method){
      case 'get':
        try{
          if(typeof payload.parameters !== 'undefined'){
            results = await this.axiosObject.get(payload.requestPath, {
              params : payload.parameters
            });
          }else{
            results = await this.axiosObject.get(payload.requestPath);
          }
        }catch(err){
          let trueResponse = null;

          if(typeof err.response !== 'undefined'){
            trueResponse = err.response;
          }else{
            trueResponse = {
              status  : 404,
              data    : null,
            };
          }

          results = {
            status  : trueResponse.status,
            data    : trueResponse.data
          }
        }
      break;

      case 'post':
        try{
          if(typeof payload.parameters !== 'undefined'){
            const postParameters = this.getURLSearchParams(payload.parameters);
            results = await this.axiosObject.post(payload.requestPath, postParameters);
          }else{
            results = await this.axiosObject.post(payload.requestPath);
          }
        }catch(err){
          let trueResponse = null;

          if(typeof err.response !== 'undefined'){
            trueResponse = err.response;
          }else{
            trueResponse = {
              status  : 404,
              data    : null,
            };
          }

          results = {
            status  : trueResponse.status,
            data    : trueResponse.data
          }
        }
      break;

      case 'post-multipart':
        try{
          if(typeof payload.parameters !== 'undefined'){
            const postParameters = this.getFormData(payload.parameters);
            results = await this.axiosObject.post(payload.requestPath, postParameters, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
          }else{
            results = await this.axiosObject.post(payload.requestPath);
          }
        }catch(err){
          let trueResponse = null;

          if(typeof err.response !== 'undefined'){
            trueResponse = err.response;
          }else{
            trueResponse = {
              status  : 404,
              data    : null,
            };
          }

          results = {
            status  : trueResponse.status,
            data    : trueResponse.data
          }
        }
      break;

      case 'delete':
        results = await this.axiosObject.delete(payload.requestPath, {
          params : payload.parameters
        });
      break;
    }

    return results;
  }

  getURLSearchParams(parametersObj){
    let params = new URLSearchParams();

    for(let i in parametersObj){
      if(parametersObj[i] !== null){
        params.append(i, parametersObj[i]);
      }
    }

    return params;
  }

  getFormData(parametersObj){
    let formData = new FormData();

    for(let i in parametersObj){
      if(parametersObj[i] !== null){
        if(typeof parametersObj[i] === 'object'){
          for(let value of parametersObj[i]){
            formData.append(i+'[]', value);
          }
        }else{
          formData.append(i, parametersObj[i]);
        }
      }
    }

    return formData;
  }

  isRequireReAuthencation(){
    // AccessTokenが存在しない場合は評価しません。
    if((this.accessToken === '') || (this.accessToken === null)){
      return false;
    }

    // アクセストークンが使用可能かを確認します。
    if( !this.isAccessTokenRequestable() ){
      return true;
    }

    return false;
  }

  initializeAxiosObject(){
    const parameters = {
      baseURL           : this.baseURL,
      withCredentials   : true,
      headers: {
        'Content-Type'  : 'application/x-www-form-urlencoded',
        'Accept'        : 'application/json',
      }
    };

    switch(this.tokenType){
      case 'Bearer':
        // accessTokenが存在する場合はHeaderに入れます。
        if( (this.accessToken !== '') && (this.accessToken !== null) ){
          parameters.headers['Authorization'] = 'Bearer '+this.accessToken;
        }
      break;

      case 'web':
        if( (this.csrfToken !== '') && (this.csrfToken !== null) ){
          parameters.headers['X-Requested-With'] = 'XMLHttpRequest';
          parameters.headers['X-CSRF-TOKEN'] = this.csrfToken;
        }
      break;
    }

    // axiosオブジェクトを作成
    return axios.create(parameters);
  }

  isAccessTokenRequestable(){
    if((this.accessToken !== null) && (this.accessToken !== '')){
      return this.isAlive( this.decodeJWT(this.accessToken) );
    }else{
      return false;
    }
  }

  isRefreshTokenRequestable(){
    if((this.refreshToken !== null) && (this.refreshToken !== '')){
      return this.isAlive( this.decodeJWT(this.refreshToken) );
    }else{
      return false;
    }
  }

  decodeJWT(jwtToken){
    const base64Url = jwtToken.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(decodeURIComponent(escape(window.atob(base64))));
  }

  isAlive(decoded) {
    const nowDate = Date.now().valueOf() / 1000;
    if( (typeof decoded.exp !== 'undefined') && (decoded.exp < nowDate) ){
      return false;
    }

    if( (typeof decoded.nbf !== 'undefined') && (decoded.nbf > nowDate) ){
      return false;
    }

    return true;
  }
}
